import apiClient from './_client';

export default {
    checkUrl(url) {
        return apiClient.post('utils/check-url', {url}).then(result => {
            return result;
        });
    },
    validateCoupon(couponCode) {
        return apiClient.post('utils/validate-coupon', {couponCode}).then(result => {
            return result.coupon;
        });
    },
}
